module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie SpriteMap is a wrapper around the sprite.html containing the SVG symbols for the Nessie Icon component.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;SpriteMap/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/SpriteMap/README.md
// module id = 390
// module chunks = 0